module.exports = __webpack_public_path__ + "img/USD.9774266c.png";